import React from "react";
import {useAdmin} from "../../contexts/AdminContext";
import {useTranslation} from "react-i18next";

const CurrentSubscription: React.FC = () => {
    const { subscription } = useAdmin()
    const {t} = useTranslation(['settings'])

    return subscription ? (
        <div className={'pb-3'}>
            <p>
                {t("subscription.key")}: {subscription.key}<br/>
                {t("subscription.type")}: {subscription.type === 'subscription'
                ? t('subscription.subscribed')
                : ((subscription.type === 'trial')
                    ? t("subscription.trialPeriod") :
                    t("subscription.development"))}<br/>
                Start: {subscription.created_at}<br/>
                {t("subscription.validUntil")}: {subscription.expire_date}<br/>
                {t("subscription.valid")}: {subscription.valid
                ? t("subscription.yes")
                : t("subscription.no")}<br/>
                {subscription.plans &&
                    <>{t("subscription.plans")}:
                        <ul>
                            {subscription.plans.map((p) => <li>{p.name}</li>)}
                        </ul>
                    </>
                }
            </p>
        </div>
    ) : null
}

export default CurrentSubscription
